import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const PoweredByWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 24px;
  opacity: 0.7;
  > span {
    font-style: normal;
    font-weight: 700;
    ${fontSize(10)}
    line-height: 120%;
    color: ${colors.text.kleinBlue};
  }
  @media only screen and ${sizes.max991} {
    margin-top: 4.8vw;
    gap: 1.4vw;
    margin-bottom: 4.8vw;
  }
`;
